import { Button } from '@material-ui/core';
import React from 'react';
import GoogleIcon from '@mui/icons-material/Google';
import { auth, provider, signInWithPopup } from '../utils/firebase';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import userService from '../user.service';

const LoginWithGoogle = () => {
  const history = useNavigate();

  const handleGoogleSignIn = async () => {
    try {
      const result = await signInWithPopup(auth, provider);
      const user = result.user;

      const idToken = await user.getIdToken();

      const { data } = await axios.post(
        process.env.REACT_APP_EXPRESS_URL + `/api/canCare/socialSignin`,
        {},
        {
          headers: {
            'Content-Type': 'application/json',
            authorization: idToken,
          },
        },
      );
      const loginData = data?.data || null;

      if (loginData?.user) {
        userService.updateAuthData({
          accessToken: loginData.id,
          currentUserId: loginData.userId,
          rememberMe: true,
        });

        userService.updateStorage({
          accessToken: loginData.id,
          currentUserId: loginData.userId,
          rememberMe: true,
        });

        userService.updateCurrentUser(loginData.user);
        localStorage.setItem('auth', loginData.id + '~29#215@rfeqwEt0');
        history('/main');
      }
    } catch (error) {
      console.error('Error signing in with Google:', error);
    }
  };

  return (
    <Button variant="outlined" onClick={handleGoogleSignIn} color="primary">
      <GoogleIcon style={{ marginRight: '10px', padding: '6px', color: '#3F50B5' }} /> Continue with Google
    </Button>
  );
};

export default LoginWithGoogle;
